module.exports = __webpack_public_path__ + "img/web-p2-f5.11c4b05c.svg";